// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.volumeSliderContainer_Q44Of {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: var(--fa-background);
    border: 1px solid var(--cb-border);
    border-radius: 5px;
    display: flex;
    align-items: center;
}

.sliderContainer_o8e5G {
    position: relative;
    width: 100%;
    height: 60%;
    margin: 0 5px;
    display: flex;
    align-items: center;
}

.sliderBackground_Zfx6J {
    position: absolute;
    height: 100%;
    background-color: var(--_18181b-color);
    border-radius: 5px;
    top: 0;
    left: 0;
    z-index: 0;
    pointer-events: none;
}

.volumeSlider_sHZh8 {
    position: relative;
    width: 100%;
    height: 60%;
    -webkit-appearance: none;
    background: transparent;
    outline: none;
    padding: 0;
    margin: 0;
    z-index: 1;
    cursor: pointer;
}

.volumeSlider_sHZh8::-webkit-slider-thumb {
    appearance: none;
    width: 21px;
    height: 60%;
    border-radius: 5px;
    border: 1px solid var(--ced4da-border);
    background: var(--_c9-background);
    cursor: pointer;
    border: none;
    box-shadow: none;
}

.volumeSlider_sHZh8::-moz-range-thumb {
    width: 21px;
    height: 60%;
    border-radius: 5px;
    border: 1px solid var(--ced4da-border);
    background: var(--_c9-background);
    cursor: pointer;
    border: none;
    box-shadow: none;
}




.volumeSliderContainerMinimal_UFJ5y {
    width: 100%;
    padding: 20px 0;
  }

  .sliderContainerMinimal_MX3ZM {
    position: relative;
    height: 20px;
    width: 100%;
  }

  .sliderLineMinimal_NkIV6 {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #bebebeaf;
    transform: translateY(-50%);
    z-index: 1;
  }

  .sliderActiveLineMinimal_O4HLz {
    position: absolute;
    top: 50%;
    height: 2px;
    background-color: var(--_2-color);
    transform: translateY(-50%);
    z-index: 2;
  }

  .sliderIndicatorMinimal_wOH_p {
    position: absolute;
    top: 50%;
    width: 14px;
    height: 14px;
    background-color: var(--f5-background);
    border: 2px solid var(--_2-color);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    pointer-events: none;
    cursor: pointer;
  }

  .nativeSliderMinimal_rB5VT {
    width: 100%;
    position: relative;
    z-index: 4;
    background: transparent;
    opacity: 0;
    cursor: pointer;
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/VolumeSlider/VolumeSlider.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IAEI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,iCAAiC;IACjC,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,iCAAiC;IACjC,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;;;;AAKA;IACI,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,iCAAiC;IACjC,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,iCAAiC;IACjC,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;IACV,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,UAAU;IACV,eAAe;EACjB","sourcesContent":[".volumeSliderContainer {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background-color: var(--fa-background);\n    border: 1px solid var(--cb-border);\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n}\n\n.sliderContainer {\n    position: relative;\n    width: 100%;\n    height: 60%;\n    margin: 0 5px;\n    display: flex;\n    align-items: center;\n}\n\n.sliderBackground {\n    position: absolute;\n    height: 100%;\n    background-color: var(--_18181b-color);\n    border-radius: 5px;\n    top: 0;\n    left: 0;\n    z-index: 0;\n    pointer-events: none;\n}\n\n.volumeSlider {\n    position: relative;\n    width: 100%;\n    height: 60%;\n    -webkit-appearance: none;\n    background: transparent;\n    outline: none;\n    padding: 0;\n    margin: 0;\n    z-index: 1;\n    cursor: pointer;\n}\n\n.volumeSlider::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 21px;\n    height: 60%;\n    border-radius: 5px;\n    border: 1px solid var(--ced4da-border);\n    background: var(--_c9-background);\n    cursor: pointer;\n    border: none;\n    box-shadow: none;\n}\n\n.volumeSlider::-moz-range-thumb {\n    width: 21px;\n    height: 60%;\n    border-radius: 5px;\n    border: 1px solid var(--ced4da-border);\n    background: var(--_c9-background);\n    cursor: pointer;\n    border: none;\n    box-shadow: none;\n}\n\n\n\n\n.volumeSliderContainerMinimal {\n    width: 100%;\n    padding: 20px 0;\n  }\n\n  .sliderContainerMinimal {\n    position: relative;\n    height: 20px;\n    width: 100%;\n  }\n\n  .sliderLineMinimal {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: #bebebeaf;\n    transform: translateY(-50%);\n    z-index: 1;\n  }\n\n  .sliderActiveLineMinimal {\n    position: absolute;\n    top: 50%;\n    height: 2px;\n    background-color: var(--_2-color);\n    transform: translateY(-50%);\n    z-index: 2;\n  }\n\n  .sliderIndicatorMinimal {\n    position: absolute;\n    top: 50%;\n    width: 14px;\n    height: 14px;\n    background-color: var(--f5-background);\n    border: 2px solid var(--_2-color);\n    border-radius: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 3;\n    pointer-events: none;\n    cursor: pointer;\n  }\n\n  .nativeSliderMinimal {\n    width: 100%;\n    position: relative;\n    z-index: 4;\n    background: transparent;\n    opacity: 0;\n    cursor: pointer;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"volumeSliderContainer": `volumeSliderContainer_Q44Of`,
	"sliderContainer": `sliderContainer_o8e5G`,
	"sliderBackground": `sliderBackground_Zfx6J`,
	"volumeSlider": `volumeSlider_sHZh8`,
	"volumeSliderContainerMinimal": `volumeSliderContainerMinimal_UFJ5y`,
	"sliderContainerMinimal": `sliderContainerMinimal_MX3ZM`,
	"sliderLineMinimal": `sliderLineMinimal_NkIV6`,
	"sliderActiveLineMinimal": `sliderActiveLineMinimal_O4HLz`,
	"sliderIndicatorMinimal": `sliderIndicatorMinimal_wOH_p`,
	"nativeSliderMinimal": `nativeSliderMinimal_rB5VT`
};
export default ___CSS_LOADER_EXPORT___;
